import qs from "qs";
import API from "../../../Api/Api";
import { API_END_POINT } from "../../../Api/EndPoints";
import { isDefined } from "../../../Utils";
import moment from "moment-timezone";

export const getTotalComission = (ba, formData) => {
  let totalComission = 0;
  const currComissions = ba?.attributes?.comissions?.data;

  formData?.products?.forEach((item) => {
    const rangeId = item?.gamme?.data?.id;
    const itemId = item?.panierItemId;
    const currentComission = currComissions?.find((comission) => {
      return +rangeId === +comission?.attributes?.range?.data?.id;
    });
    const panierItem = formData?.panierItems?.data?.find(
      (panierItem) => +panierItem?.id === +itemId
    );

    const panierItemAmountTTC = panierItem?.attributes?.itemAmount;
    const panierItemAmountHT =
      formData?.createdAt < "2024-03-12" && formData?.oldId
        ? panierItemAmountTTC / 1.2
        : panierItemAmountTTC;
    const panierItemPdtPrice =
      panierItem?.attributes?.product?.data?.attributes?.retailerPriceHT;

    if (isDefined(currentComission)) {
      totalComission +=
        ((panierItemAmountHT
          ? +panierItemAmountHT - panierItem?.attributes?.discount
          : +panierItemPdtPrice - panierItem?.attributes?.discount) *
          +currentComission?.attributes?.value) /
        100;
      // totalComission +=
      //   (+item?.retailerPriceHT - +item?.deliveredCost) *
      //   (+currentComission?.attributes?.value / 100);
    }
  });
  return totalComission;
};

export const getComission = async (id) => {
  try {
    const query = qs.stringify({
      populate: {
        comissions: {
          populate: {
            range: true,
          },
        },
      },
    });
    const {
      data: { data: ba },
    } = await API.get(`${API_END_POINT}api/business-affiliates/${id}?${query}`);
    return ba;
  } catch (error) {
    return 0;
  }
};

export const getTotalDeliveredCostBuyingCost = (panierItems) => {
  try {
    return panierItems?.length > 0
      ? panierItems?.reduce((acc, item) => {
          const packing = item?.attributes?.packings?.data[0];
          const buyingCost = packing?.attributes?.buyingCost;
          const deliveredCost = packing?.attributes?.deliveredCost;
          const productType =
            packing?.attributes?.model?.data?.attributes?.productType;

          return acc + (productType === 1 ? deliveredCost : buyingCost);
        }, 0)
      : 0;
  } catch (error) {
    console.log(error);
  }
};

export const netMargin = ({
  commission = 0,
  montantHT = 0,
  deliveredCost = 0,
  deliveryPrice = 0,
}) => {
  return parseFloat(montantHT - +deliveredCost - +deliveryPrice).toFixed(2); // minus delivery price but it is integrated in montantHT
};

export const getOrderStatus = (status) => {
  switch (status) {
    case 1:
      return "En attente";
    case 2:
      return "Livrée";
    case 4:
      return "Acompte";
    case 5:
      return "Payée/en attente de livraison";
    default:
      return "-";
  }
};

const isValidDate = (value) => {
  return moment(value).isValid();
};

export const getDiscount = ({
  discount,
  discountStartDate,
  discountEndDate,
}) => {
  const timezone = "Europe/Paris";

  const today = moment().tz(timezone);
  const startDate = isValidDate(discountStartDate)
    ? moment(discountStartDate).tz(timezone).startOf("day")
    : null;
  const endDate = isValidDate(discountEndDate)
    ? moment(discountEndDate).tz(timezone).endOf("day")
    : null;

  const isTodayWithinRange = today.isBetween(
    startDate,
    endDate,
    undefined,
    "[]"
  );

  return discount > 0 && isTodayWithinRange ? discount : 0;
};
